export default "__VITE_ASSET__b67fa520__"